import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDialog, MAT_DATE_FORMATS } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../core/format-datepicker';
import { Appointment } from '../../core/model/v2/appointment/appointment';
import { AppointmentStatus } from '../../core/model/v2/appointment/appointment-status';
import { AppointmentSlots } from '../../core/model/v2/appointment/appointmentSlots';
import { AppyUser } from '../../core/model/v2/AppyUser';
import { Practitioner } from '../../core/model/v2/practitioner/practitioner';
import { Patient } from '../../core/models/patient/patient';
import { AppointmentsService } from '../../core/services/v2/appointments.service';
import { PatientService } from '../../core/services/v2/patient.service';
import { PracticeService } from '../../core/services/v2/practice.service';
import { UserService } from '../../core/services/v2/user.service';
import { UtilsService } from '../../core/services/v2/utils.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-call-center-appointment',
  templateUrl: './call-center-appointment.component.html',
  styleUrls: ['./call-center-appointment.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }]
})
export class CallCenterAppointmentComponent implements OnInit {
  requestAppointmentForm: FormGroup;
  appointmentId: number;
  appointment: Appointment;
  patientId: number;
  providerId: number;
  healthSystemId: number;
  patient: Patient;
  provider: Practitioner;
  availableSlotsList: any;
  isTreatmentSelected: boolean;
  YesNoArray = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];
  treatments: any;
  services: any;
  user: AppyUser;
  minDate: Date = new Date();
  selectedDates: Date[] = [];
  showConfirmAppt: boolean = true;
  formDataChanged: boolean = false;
  userSelectedSlotId: FormControl = new FormControl('');

  constructor(
    private userService: UserService,
    private patientService: PatientService,
    private practiceService: PracticeService,
    private appointmentService: AppointmentsService,
    public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
  ) { }

  ngOnInit() {
    this.fetchParams();
    this.requestAppointmentForm = this.fb.group({
      patientId: [this.patientId, Validators.required],
      userId: ['', Validators.required],
      practitionerId: [this.providerId, Validators.required],
      healthSystemId: [this.healthSystemId, Validators.required],
      date: ['', Validators.required],
      requestedSlot: ['', Validators.required],
      spotSelected: [false, Validators.required],
      spotDate: ['', Validators.required],
      urgencyType: ['Select Date', Validators.required],
      anotherPractiotioner: [false, Validators.required],
      treatment: [null],
      service: [null],
      symptom: [null],
      symptomBeginDate: [null],
      symptomDetails: [null],
      isWorkRelatedInjury: [null],
      isMotorVehicleAccident: [false],
      isSymptomExistsEarlier: [null],
      isTestDone: [null],
      testResults: [null],
      seenAnyDoctorEarlier: [null],
      isVirtualVisit: [false]
    });
    this.fetchData();
  }

  fetchParams() {
    this.patientId = +this.route.snapshot.paramMap.get('patientId');
    this.providerId = +this.route.snapshot.paramMap.get('providerId');
    this.healthSystemId = +this.route.snapshot.paramMap.get('healthSystemId');
    this.appointmentId = +this.route.snapshot.paramMap.get('appointmentId');
    if (!this.patientId || !this.providerId || !this.healthSystemId) {
      this.router.navigate(["/callcenter/appointmentlist"]);
    }
  }

  fetchData() {
    this.getPatient(this.patientId);
    this.getProvider(this.providerId);
    this.userService.getUserDetails().subscribe((user) => {
      this.user = user;
    });
    if (this.appointmentId) {
      this.getAppointment(this.appointmentId);
    }
  }

  getPatient(id) {
    this.loaderService.blockWithLoader(this.patientService.getPatientDetailsById(id)).subscribe(
      (details) => {
        this.patient = details;
        console.log('Patient', this.patient);
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  getProvider(id) {
    this.loaderService.blockWithLoader(this.practiceService.getPractitionerDetails(id)).subscribe(
      (details) => {
        this.provider = details;
        this.treatments = details.practitionerTreatments;
        this.loadServices();
        console.log('Provider', this.provider);
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }
  loadServices() {
    this.practiceService.getPractitionerServicesByPractitionerId(this.providerId).subscribe(
      (details) => {
        this.services = [];
        let data = details.serviceData;
        if (data) {
          let serviceData = JSON.parse(data);
          if (serviceData && serviceData.location) {
            let datanew = serviceData.location.map(x => x.services);
            if (datanew) {
              this.services = [].concat(...datanew);
            }
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );

  }

  getAppointment(id) {
    this.loaderService.blockWithLoader(this.appointmentService.getAppointmentById(id)).subscribe(
      (details) => {
        this.appointment = details;
        if (this.appointment.status == AppointmentStatus.APPOINTMENT_CANCELLED) {
          this.utils.showMessageSnackBar('This appointment is already cancelled.', true);
          this.goToDashboard();
        }
        this.bindAppointmentWithForm();
        if (details.service) {
          this.disableFormFields();
        }
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  bindAppointmentWithForm() {
    this.requestAppointmentForm.patchValue(this.appointment);
    console.log('appointment data - ', this.appointment);
    this.requestAppointmentForm.get('date').setValue(null);
    this.onCreateGroupFormValueChange();
    if (this.appointment.status == AppointmentStatus.APPOINTMENT_SCHEDULED) {
      this.disableFormFields(true);
    }
  }

  onCreateGroupFormValueChange() {
    const initialValue = this.requestAppointmentForm.value;
    this.requestAppointmentForm.valueChanges.subscribe(value => {
      if (!this.formDataChanged) {
        this.formDataChanged = Object.keys(initialValue).some(key => value[key] != initialValue[key]);
      }
    });
  }

  updateFormDate(value: any) {
    this.requestAppointmentForm.get('date').setValue(value);
    const slot = this.requestAppointmentForm.get('requestedSlot').value;
    if (slot) {
      this.getFreeAppointmentAllottedSlots();
    }
  }

  getFreeAppointmentAllottedSlots() {
    const date = this.requestAppointmentForm.controls.date.value;
    const slot = this.requestAppointmentForm.controls.requestedSlot.value;
    if (!date) {
      this.utils.showMessageSnackBar('please select Date first.', true);
      this.requestAppointmentForm.controls.requestedSlot.setValue('');
      return;
    }
    if (!slot) {
      this.utils.showMessageSnackBar('please select Slot first.', true);
      this.requestAppointmentForm.controls.requestedSlot.setValue('');
      return;
    }
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let exactDate = `${year}-${month}-${day}`;

    const period = slot == 'Morning' ? 'AM' : 'PM';

    this.appointmentService.GetFreeAppointmentAllottedSlots(this.providerId, this.healthSystemId, exactDate, period).subscribe(
      (details) => {
        this.availableSlotsList = details.appointmentAllottedSlots;
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );

  }

  onTreatmentChange(event: any) {
    this.isTreatmentSelected = true;
    this.requestAppointmentForm.controls.service.setValue(null);
    this.enableFormFields();
  }

  onServiceChange(event: any) {
    this.isTreatmentSelected = false;
    this.requestAppointmentForm.controls.treatment.setValue(null);
    this.disableFormFields();
  }

  disableFormFields(disableAll: boolean = false) {
    if (disableAll) {
      this.requestAppointmentForm.get('treatment').disable();
      this.requestAppointmentForm.get('service').disable();
    }
    this.requestAppointmentForm.get('symptom').disable();
    this.requestAppointmentForm.get('symptomBeginDate').disable();
    this.requestAppointmentForm.get('symptomDetails').disable();
    this.requestAppointmentForm.get('isWorkRelatedInjury').disable();
    this.requestAppointmentForm.get('isSymptomExistsEarlier').disable();
    this.requestAppointmentForm.get('isTestDone').disable();
    this.requestAppointmentForm.get('testResults').disable();
    this.requestAppointmentForm.get('seenAnyDoctorEarlier').disable();
  }

  enableFormFields() {
    this.requestAppointmentForm.get('symptom').enable();
    this.requestAppointmentForm.get('symptomBeginDate').enable();
    this.requestAppointmentForm.get('symptomDetails').enable();
    this.requestAppointmentForm.get('isWorkRelatedInjury').enable();
    this.requestAppointmentForm.get('isSymptomExistsEarlier').enable();
    this.requestAppointmentForm.get('isTestDone').enable();
    this.requestAppointmentForm.get('testResults').enable();
    this.requestAppointmentForm.get('seenAnyDoctorEarlier').enable();
  }

  addTimeSlot() {
    let formData = this.requestAppointmentForm.getRawValue();
    if (!formData.spotDate) {
      this.utils.showMessageSnackBar('Please select a time slot first.', true);
      return;
    }
    if (this.selectedDates.find(x => x == formData.spotDate)) {
      this.utils.showMessageSnackBar('slot is already selected.', true);
      return;
    }
    this.selectedDates.push(formData.spotDate);
    this.showConfirmAppt = false;
  }

  removeTimeSlot(date: Date) {
    const index = this.selectedDates.findIndex(x => x == date);
    this.selectedDates.splice(index, 1);
    if (this.selectedDates.length == 0) {
      this.showConfirmAppt = true;
    }
  }

  requestAppointment() {
    console.log(this.requestAppointmentForm);
    const res = this.validateAppointment();
    if (!res) {
      return;
    }
    let formData = this.requestAppointmentForm.getRawValue();

    let appointmentDate = this.getFormatedDate(new Date());
    if (formData.urgencyType == 'Select Date') {
      appointmentDate = formData.spotDate;
      formData.spotSelected = true;
    }
    else {
      formData.spotSelected = false;
    }
    let symptomStartDate = null;
    if (formData.symptomBeginDate) {
      symptomStartDate = this.getFormatedDate(formData.symptomBeginDate);
    }

    let data: any = {
      patientId: formData.patientId,
      userId: this.user.id,
      date: appointmentDate,
      spotSelected: formData.spotSelected,
      symptom: formData.symptom,
      practitionerId: formData.practitionerId,
      fromPractitionerId: 0,
      healthSystemId: formData.healthSystemId,
      requestedSlot: formData.requestedSlot,
      isMotorVehicleAccident: formData.isMotorVehicleAccident,
      isWorkRelatedInjury: formData.isWorkRelatedInjury,
      isSymptomExistsEarlier: formData.isSymptomExistsEarlier,
      isTestDone: formData.isTestDone,
      seenAnyDoctorEarlier: formData.seenAnyDoctorEarlier,
      patientInsuranceId: 0,
      isVirtualVisit: formData.isVirtualVisit,
      symptomBeginDate: symptomStartDate,
      symptomDetails: formData.symptomDetails,
      testResults: formData.testResults,
      urgencyType: formData.urgencyType,
      treatment: formData.treatment,
      service: formData.service,
      anotherPractiotioner: formData.anotherPractiotioner,
      createdBy: this.user.id,
      byCallCareCoordinator: true
    }
    this.loaderService.blockWithLoader(this.appointmentService.createAppointment(data)).subscribe(
      (data) => {
        if (data.response.isSuccess) {
          this.utils.showMessageSnackBar('Appointment request submitted successfully.');
          this.goToDashboard();
        }
        else {
          this.utils.showMessageSnackBar(data.response.message, true);
        }
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }

  validateAppointment(toUpdate: boolean = false): boolean {
    let errorMessageList = [];
    if (!toUpdate && !this.requestAppointmentForm.controls.spotDate.value) {
      errorMessageList.push('Please select Appointment date and slot first before requesting.');
    }
    if (!this.requestAppointmentForm.controls.treatment.value && !this.requestAppointmentForm.controls.service.value) {
      errorMessageList.push('Please select either Treatment or Service.');
    }
    if (errorMessageList.length > 0) {
      this.requestAppointmentForm.markAllAsTouched();
      this.utils.showMessageSnackBar(errorMessageList.join('\r\n'), true);
      return false;
    }
    return true;
  }

  private getFormatedDate(date: Date) {
    if (!date) {
      return null;
    }
    let dateObj = new Date(date);
    let day = ('0' + dateObj.getDate()).slice(-2);
    let month = ('0' + (dateObj.getMonth() + 1)).slice(-2);

    let year = dateObj.getFullYear();

    return `${year}-${month}-${day}`;
  }

  confirmAppointment() {

    Swal.fire({
      title: `Confirm Appointment`,
      text: `Are you sure want to confirm appointment with Dr. ${this.provider.fullName}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.appointment && this.appointment.status == 'PROVIDER_AVAILABILITY_SET') {
          const selectedSlotId = this.userSelectedSlotId.value;
          if (!selectedSlotId) {
            this.utils.showMessageSnackBar('Please select slot first.', true);
            return;
          }
          const apptSlotObj = {
            "appointmentId": this.appointment.id,
            "status": AppointmentStatus.PATIENT_SELECTED_APPOINTMENTSLOT,
            "slotId": selectedSlotId
          };
          this.loaderService.blockWithLoader(this.appointmentService.updateAppointmentStatus(apptSlotObj)).subscribe(
            (res) => {
              if (res.response.isSuccess) {
                this.confirmAppt();
              }
              else {
                this.utils.showMessageSnackBar(res.response.message, true);
              }
            },
            (error) => {
              this.utils.showMessageSnackBar(error, true);
              console.error(error);
            }
          );
        }
        else {
          this.confirmAppt();
        }
      }
    })
  }
  private confirmAppt() {
    var appointment = {
      appointmentId: this.appointment.id,
      status: AppointmentStatus.APPOINTMENT_SCHEDULED,
      slotId: 0,
    };
    if (this.formDataChanged) {
      this.updateAppointment();
    }
    this.loaderService.blockWithLoader(this.appointmentService.updateAppointmentStatus(appointment)).subscribe(
      (res) => {
        if (res.response.isSuccess) {
          this.utils.showMessageSnackBar(`appointment with Dr. ${this.provider.fullName} has been confirmed`);
          this.goToDashboard();
        }
        else {
          this.utils.showMessageSnackBar(res.response.message, true);
        }
      },
      (error) => { console.error(error); this.loaderService.hide() }
    );
  }

  sendSelectedDate(): void {
    var slots = {
      appointmentId: this.appointment.id,
      appointment: null,
      appointmentAllottedSlots: []
    };

    this.selectedDates.forEach(date => {
      slots.appointmentAllottedSlots.push({
        appointmentDate: moment(moment(date).format('YYYY-MM-DDTHH:mm:ss+00:00')).utc(false).toDate(),
        startTime: moment(date).format('HH:mm'),
        endTime: moment(date).add(30, 'minutes').format('HH:mm')
      });
    });
    if (this.formDataChanged) {
      this.updateAppointment().subscribe(
        (data) => {
          if (data.response.isSuccess) {
            this.loaderService.blockWithLoader(this.appointmentService.assignAppointmentSlots(slots)).subscribe(
              (res) => {
                if (res.response.isSuccess) {
                  this.utils.showMessageSnackBar('Appointment slots sent to the patient successfully.');
                  this.goToDashboard();
                }
                else {
                  this.utils.showMessageSnackBar(res.response.message, true);
                }
              },
              (error) => { console.error(error); this.loaderService.hide() }
            );
          }
          else {
            this.utils.showMessageSnackBar(data.response.message, true);
          }
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
    }

  }

  updateAppointment(): Observable<any> {
    const res = this.validateAppointment(true);
    if (!res) {
      return;
    }

    let formData = this.requestAppointmentForm.getRawValue();

    let symptomStartDate = null;
    if (formData.symptomBeginDate) {
      symptomStartDate = this.getFormatedDate(formData.symptomBeginDate);
    }

    let data: any = {
      id: this.appointment.id,
      userId: this.user.id,
      symptom: formData.symptom,
      isMotorVehicleAccident: formData.isMotorVehicleAccident,
      isWorkRelatedInjury: formData.isWorkRelatedInjury,
      isSymptomExistsEarlier: formData.isSymptomExistsEarlier,
      isTestDone: formData.isTestDone,
      seenAnyDoctorEarlier: formData.seenAnyDoctorEarlier,
      patientInsuranceId: 0,
      symptomBeginDate: symptomStartDate,
      symptomDetails: formData.symptomDetails,
      testResults: formData.testResults,
      urgencyType: formData.urgencyType,
      treatment: formData.treatment,
      service: formData.service,
      anotherPractiotioner: formData.anotherPractiotioner,
    }
    return this.loaderService.blockWithLoader(this.appointmentService.updateAppointment(data));
  }

  cancelAppointment() {
    if (!this.appointment) {
      this.utils.showMessageSnackBar('Appointment can not be cancelled.', true);
    }
    if (!this.IsCancelAllowed()) {
      return;
    }
    Swal.fire({
      title: `Cancel Appointment`,
      text: `Are you sure want to cancel appointment with Dr. ${this.provider.fullName}.?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      const apptCancelObj = {
        "appointmentId": this.appointment.id,
        "status": AppointmentStatus.APPOINTMENT_CANCELLED
      };

      this.loaderService.blockWithLoader(this.appointmentService.updateAppointmentStatus(apptCancelObj)).subscribe(
        (res) => {
          if (res.response.isSuccess) {
            this.utils.showMessageSnackBar(`Appointment with Dr. ${this.appointment.practitioner.fullName} has been cancelled successfully.`);
            this.goToDashboard();
          }
          else {
          }
        },
        (error) => {
          this.utils.showMessageSnackBar(error, true);
          console.error(error);
        }
      );
    });
  }

  IsCancelAllowed() {
    const currentDateTime = new Date();
    const appointmentData = this.appointment.startDateTime ? moment(this.appointment.startDateTime) : moment(this.appointment.date);
    const hoursDifference = appointmentData.diff(currentDateTime, 'hours')

    if (hoursDifference <= 24) {
      this.utils.showMessageSnackBar(`You can not cancel appointment before 24 hours.`, true);
      return false;
    }
    return true;
  }

  goToDashboard() {
    this.router.navigate(['/callcenter/appointmentlist']);
  }

  showSendSelectedDateBtn(): boolean {
    return (this.appointment
      && (this.appointment.status == 'PATIENT_AVAILABILITY_SET' || this.appointment.status == 'PATIENT_SELECTED_APPOINTMENTSLOT')
      && this.selectedDates.length > 0)
  }

  showConfirmApptBtn(): boolean {
    return (this.showConfirmAppt
      && this.appointment
      && (this.appointment.status == 'PATIENT_SELECTED_APPOINTMENTSLOT' || this.appointment.status == 'PROVIDER_AVAILABILITY_SET'))
  }

}
